import { ArrowRightIcon } from "@icons";
import { VStack } from "@design-system/VStack/VStack";
import { ScheduleType } from "@common/types/domains/accounting/schedule";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { ApplySourceType } from "./ScheduleApplyFields";
import {
    ApplySourceDestination,
    EXTERNAL_SOURCE_OPTIONS,
    getInKickSourceOptions,
    SourceOption,
} from "./scheduleApplySourceOptions";
import styles from "./ScheduleApplyModal.module.scss";

export type { ApplySourceDestination };

interface ScheduleApplySourcePickerProps {
    scheduleType: ScheduleType | null;
    onSelect: (sourceType: ApplySourceType) => void;
    onNavigate: (destination: ApplySourceDestination) => void;
}

function SourceCard({
    option,
    onSelect,
    onNavigate,
}: {
    option: SourceOption;
    onSelect: (sourceType: ApplySourceType) => void;
    onNavigate: (destination: ApplySourceDestination) => void;
}) {
    return (
        <button
            type="button"
            className={styles.sourceCard}
            onClick={() => {
                if (option.action === "navigate") {
                    onNavigate(option.key);
                }
                if (option.action === "select") {
                    onSelect(option.sourceType);
                }
            }}
        >
            <span>
                <span className={styles.sourceTitle}>{option.title}</span>
                <span className={styles.sourceDescription}>
                    {option.description}
                </span>
            </span>
            <ArrowRightIcon className={styles.sourceChevron} />
        </button>
    );
}

export const ScheduleApplySourcePicker: React.FC<
    ScheduleApplySourcePickerProps
> = ({ scheduleType, onSelect, onNavigate }) => {
    const { schedulesExpenses: isBillsSourceEnabled } = useTypedFlags();
    return (
        <VStack gap={12}>
            <VStack gap={12}>
                {getInKickSourceOptions({
                    scheduleType,
                    isBillsSourceEnabled,
                }).map((option) => (
                    <SourceCard
                        key={option.key}
                        option={option}
                        onSelect={onSelect}
                        onNavigate={onNavigate}
                    />
                ))}
            </VStack>
            <p className={styles.sectionLabel}>Data outside of Kick</p>
            <VStack gap={12}>
                {EXTERNAL_SOURCE_OPTIONS.map((option) => (
                    <SourceCard
                        key={option.key}
                        option={option}
                        onSelect={onSelect}
                        onNavigate={onNavigate}
                    />
                ))}
            </VStack>
        </VStack>
    );
};
